<div class="dashboard-period-selector">
	<div class="period-field">
		<p-selectButton
			[options]="periodOptions"
			optionLabel="label"
			optionValue="value"
			[(ngModel)]="selectedPreset"
			(onChange)="onPresetChange()"
		></p-selectButton>
	</div>

	<div *ngIf="selectedPreset === 'custom'" class="period-field custom-range">
		<label>Select Date Range</label>

		<p-calendar
			[(ngModel)]="customRange"
			[minDate]="customMinDate"
			[maxDate]="customMaxDate"
			(onSelect)="onCustomDateSelect()"
			(onClear)="onCustomRangeClear()"
			[readonlyInput]="true"
			[showClear]="true"
			[showIcon]="true"
			[appendTo]="'body'"
			selectionMode="range"
			dateFormat="dd/mm/yy"
			placeholder="Select up to 31 days"
		></p-calendar>
	</div>
</div>
